<template>
<div>
    <b-card no-body border-variant="primary" class="marginal">
      <b-card-header header-bg-variant="primary" header-text-variant="white" class="text-center">Detect Live with problems</b-card-header>
      <b-card-body>

        <b-row class="marginaltop">
            <div class="col-md-4"></div>
            <b-btn @click="onSubmit" variant="primary" class="col-md-4">Refresh live with status to_encode</b-btn>
        </b-row>
        <b-row v-if="isRequestLoading" class="marginal">
          <div class="col-6"></div>
          <fade-loader color="red"></fade-loader>
        </b-row>
        <b-row v-if="videos.length > 0" class="marginal">
            <div class="col-4"></div>
            <div class="col-md-4">Number of videos found: {{videos.length}}</div>
        </b-row>
        <b-row v-if="videos.length > 0" class="marginal">
            <div class="col-4"></div>
        <download-csv
            :data="videos" name="livetoencode.csv" class="btn btn-primary col-md-4">
            Download csv of videos
        </download-csv>
        </b-row>
            
      </b-card-body>
    </b-card>

  </div>
</template>

<script>
import FadeLoader from 'vue-spinner/src/FadeLoader.vue'
import VideoService from '@/services/video.service';
var videoService = new VideoService();

let globalText = 'Global problem';

export default {
  name: 'LiveDetect',
  components: {
    'FadeLoader': FadeLoader
  },
  data: function() {
    return {
        videos: [],
        isRequestLoading: false,
        fields: [],
        fieldstext: ""
    }
  },
  mounted: function() {

  },
  methods: {
    onSubmit:function() {
        let parameters = {
            type: "live",
            encoding_status: "to_encode"
        }
        this.loadVideos(parameters);
    },
    loadVideos: function (parameters) {
      let self = this;
      this.isRequestLoading = true;
      videoService.getVideosPageForClient(this.$auth.token(), parameters).then((videos) =>{
          this.isRequestLoading = false;
          this.videos = videos;
      }).catch((err) => {
            this.videos = [];
            this.isRequestLoading = false;
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
